var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import { Flex, Box } from '../../CommonUI/Layout';
var DropDownComponent = (function (_super) {
    __extends(DropDownComponent, _super);
    function DropDownComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            opened: false,
            searchTerm: '',
            selectedItem: undefined,
        };
        _this.setOpened = _this.setOpened.bind(_this);
        _this.selectItem = _this.selectItem.bind(_this);
        _this.updateSearchTerm = _this.updateSearchTerm.bind(_this);
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        return _this;
    }
    DropDownComponent.prototype.componentDidMount = function () {
        var _a = this.props, initialValue = _a.initialValue, menuItems = _a.menuItems;
        if (typeof initialValue !== 'undefined') {
            this.setState({
                selectedItem: menuItems.find(function (_a) {
                    var value = _a.value;
                    return value === initialValue;
                })
            });
        }
    };
    DropDownComponent.prototype.componentWillReceiveProps = function (nextProps) {
        var initialValue = nextProps.initialValue, menuItems = nextProps.menuItems;
        if (typeof initialValue !== 'undefined' && menuItems) {
            var foundItem = menuItems.find(function (_a) {
                var value = _a.value;
                return value === initialValue;
            });
            if (foundItem) {
                this.setState({
                    selectedItem: foundItem,
                });
            }
        }
    };
    DropDownComponent.prototype.updateSearchTerm = function (e) {
        this.setState({ searchTerm: e.target.value });
    };
    DropDownComponent.prototype.setOpened = function () {
        var opened = this.state.opened;
        this.setState({ opened: !opened });
    };
    DropDownComponent.prototype.selectItem = function (next, item) {
        var _this = this;
        return function (event) {
            _this.setState({ selectedItem: item });
            return next(item);
        };
    };
    DropDownComponent.prototype.handleClickOutside = function () {
        this.setState({ opened: false, searchTerm: '' });
    };
    DropDownComponent.prototype.render = function () {
        var _a = this.props, children = _a.children, _b = _a.menuItems, menuItems = _b === void 0 ? [] : _b;
        var _c = this.state, selectedItem = _c.selectedItem, opened = _c.opened, searchTerm = _c.searchTerm;
        return (React.createElement(Box, null,
            React.createElement(Flex, null,
                React.createElement(Box, { width: "100%", mt: "0px" },
                    React.createElement(Flex, { flexDirection: "row", alignItems: "flex-start", justifyContent: "start" }, typeof children === 'function'
                        ? children({
                            opened: opened,
                            selectItem: this.selectItem,
                            searchTerm: searchTerm,
                            selectedItem: selectedItem,
                            setOpened: this.setOpened,
                            updateSearchTerm: this.updateSearchTerm,
                            filteredMenuItems: searchTerm
                                ? menuItems.filter(function (_a) {
                                    var label = _a.label;
                                    return label.toLowerCase().startsWith(searchTerm.toLowerCase());
                                })
                                : menuItems
                        })
                        : null)))));
    };
    return DropDownComponent;
}(React.Component));
export var DropDown = enhanceWithClickOutside(DropDownComponent);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/CommonUI/Controls/DropDown.js
// module id = 405
// module chunks = 0